// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"71":"bb4572c7","209":"90bb529b","264":"f5830491","405":"c8e8c009","425":"0ce10ac5","499":"8280dcd9","512":"e62ac151","548":"25f211e1","603":"e6c175fe","669":"92341e7f","715":"5fd30551","772":"157758c0","864":"06b76284"}[chunkId] + ".chunk.js";
};